

























import { Vue, Component } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
import { saveComment } from '../api/api';
import { isWeiXin, getQueryString, autoOpenApp } from '@/common/ts/common';

Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button);
@Component
export default class CommentInput extends Vue {
  voteName = '';
  content: string = '';
  pointOut: boolean = false;
  enabled: boolean = false;
  disabledTextarea: boolean = false;

  created() {
    autoOpenApp();

    // 登录成功后的回调函数
    window.userInfoChange = () => {
      // window.location = window.location;
    };
    if (window.udid) {
      this.disabledTextarea = false;
    } else {
      this.disabledTextarea = true;
    }
  }
  judgeState() {
    if (isWeiXin()) {
      this.pointOut = true;
    } else {
      window.location.href =
        'shangyounews://{"dt":"7","url":"' + location.href + '"}';
    }
  }
  async saveComment() {
    if (this.content) {
      if (isWeiXin()) {
        this.pointOut = true;
      } else if (window.udid) {
        const res = await saveComment({
          content: this.content,
          udid: window.udid,
          appkey: window.appkey,
        });
        if ((res as any).code !== 203) {
          Toast((res as any).msg);
        }
        if ((res as any).code === 200) {
          this.content = '';
        } else if ((res as any).code === 203) {
          setTimeout(() => {
            if (parseFloat(window.version) >= 4.5) {
              window.handleMessage('{"action":"mUserLogin","data":""}');
            } else {
              window.location.href = 'client:logout';
            }
          }, 500);
        }
      } else {
        Toast('请在上游新闻APP进行评论');
      }
    } else {
      Toast('请填写评论内容');
    }
  }
}
